<template>
    <!-- Header -->
    <mileage-header v-if="!isMobile && !props.embedded" />
    
    <!-- Desktop view - Datatable -->
    <div class="mt-3" v-if="!isMobile || props.embedded">
    <mileage-datatable 
        v-if="!isMobile || props.embedded"
        :request-id="props.requestId"
        :client-id="props.clientId"
        :tech-id="props.techId"
        :hide-filters="props.hideFilters"
        :embedded="props.embedded"
        :pm-only="props.pmOnly"
        :disable-actions="props.disableActions"
    />
    </div>
    
    <!-- Mobile view - Card list -->
    <mileage-mobile 
        v-else
        :rows="rows"
        :total="total"
        @refresh="loadData"
        @new-record="newRecord"
        @edit-record="editRecord"
    />
    
    <router-view name="modal"></router-view>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute, RouterView } from "vue-router";
import Api, { ApiResponse } from "@/services/ApiService";
import MileageDatatable from "@/components/Mileage/MileageDatatable.vue";
import MileageMobile from "@/components/Mileage/MileageMobile.vue";
import MileageHeader from "@/components/Mileage/MileageHeader.vue";

const router = useRouter();
const route = useRoute();

const props = defineProps({
    requestId: { type: [Number, String], default: null },
    clientId: { type: [Number, String], default: null },
    techId: { type: [Number, String], default: null },
    hideFilters: { type: Boolean, default: false },
    embedded: { type: Boolean, default: false },
    pmOnly: { type: Boolean, default: false },
    disableActions: { type: Boolean, default: false }
});

const isMobile = ref(false);
let mediaQuery: MediaQueryList | null = null;

const handleMediaChange = (e: MediaQueryListEvent) => {
    isMobile.value = e.matches;
};

onMounted(() => {
    if (typeof window !== 'undefined') {
        mediaQuery = window.matchMedia('(max-width: 767px)');
        isMobile.value = mediaQuery.matches;
        mediaQuery.addEventListener('change', handleMediaChange);
        if (isMobile.value && !props.embedded) { loadData(); }
    }
});

onUnmounted(() => {
    if (mediaQuery) { mediaQuery.removeEventListener('change', handleMediaChange); }
});

const total = ref(0);
const rows = ref<any[]>([]);

const loadData = async () => {
    try {
        const params: any = { Page: 0, Size: 100, IncludeRequest: true, IncludeContact: true };
        if (props.requestId) { params.RequestId = props.requestId; }
        const response: ApiResponse<any[]> = await Api.loadMileages(params);
        rows.value = response.Data || [];
        total.value = response.Meta?.Total || 0;
    } catch (error) {
        console.error('Failed to load data:', error);
        rows.value = []; total.value = 0;
    }
};

const newRecord = () => { if (!props.embedded) router.push({ path: "/mileage/new" }); };
const editRecord = (id: number) => { if (!props.embedded) router.push({ path: "/mileage/edit/" + id }); };
</script>
